import Styles from './MediaDrawer.module.scss'
import { LoadingShimmerer } from 'components/LoadingShimmerer/LoadingShimmerer'

const PLACEHOLDERS = [Styles.squarePlaceholder, Styles.portraitPlaceholder, Styles.landscapePlaceholder]

export const LoadingGrid = () => {
  return (
    <div className={Styles.mediaGrid}>
      {Array.from({ length: 9 }).map((_, index) => (
        <div key={index} className={Styles.mediaFileContainer} data-testid="loading-grid">
          <LoadingShimmerer className={PLACEHOLDERS[index % 3]} borderRadius={6} />
        </div>
      ))}
    </div>
  )
}
